import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface DuplicateNumbersReportsDownload {
    id?: number;
    number?: string;
    campaign_names: string;
}

interface DuplicateNumbersReportsState {
    duplicatenumberreportsdownloaddata: DuplicateNumbersReportsDownload[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

interface DuplicatenumbersreportsdownloadParams {
    search: string;
    page: number;
    limit: number;
}

export const GetallDuplicateNumbersReportDawnlaod = createAsyncThunk<
    Blob,
    DuplicatenumbersreportsdownloadParams,
    { rejectValue: string }
>(
    'GetallDuplicateNumbersReportDawnlaod',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/reports/duplicate-numbers-reports/download`, {
                params: {
                    search: params.search,
                    page: params.page,
                    limit: params.limit
                },
                responseType: 'blob' // Specify that you expect a Blob response
            });
            return response.data; // Return the Blob directly
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);

const initialState: DuplicateNumbersReportsState = {
    duplicatenumberreportsdownloaddata: [],
    info: null,
    error: null,
    loading: false,
};

const duplicatenumberreportdawnloadSlice = createSlice({
    name: "duplicatenumberreportdawnlaod",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-duplicate-numbers-reports-dawnlaod-slice-start============
            .addCase(GetallDuplicateNumbersReportDawnlaod.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallDuplicateNumbersReportDawnlaod.fulfilled, (state, action: PayloadAction<Blob>) => {
                state.loading = false;
            })
            .addCase(GetallDuplicateNumbersReportDawnlaod.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-duplicate-numbers-reports-dawnlaod-slice-end============      
    },
});


export default duplicatenumberreportdawnloadSlice.reducer;
